import { useState } from "react";
import { useIntl } from "react-intl";
import type { Asset } from "../../../../models/asset";
import useAssetCampaign from "../../../../hooks/useAssetCampaign";
import InfoDialog from "../../../../components/dialogs/InfoDialog";

interface ICampaignsDialogProps {
    asset: Asset;
}

export const CampaignsDialog = (props: ICampaignsDialogProps) => {
    const intl = useIntl();
    const { hasCampaign } = useAssetCampaign();

    const [campaignDialog, setCampaignDialog] = useState(false);
    const [campaignsSize, ] = useState(props.asset?.campaigns?.number ?? 0);

    return (
        <>
            {hasCampaign(props.asset) ? (
                <div className="acoes-oficina cursor-pointer text-center" onClick={() => setCampaignDialog(true)}>
                    <div style={{ position: 'relative' }}>
                        <span className="rioglyph rioglyph-calendar-today" />
                        {campaignsSize > 0 && (
                            <span className="alert-info">{campaignsSize}</span>
                        )}
                    </div>
                </div>
            ) : (
                <div className="acoes-oficina text-center">
                    <span className="rioglyph rioglyph-calendar-today" />
                </div>
            )}

            <InfoDialog
                show={campaignDialog}
                title={intl.formatMessage({ id: "intl-msg:common.fieldCampaigns" })}
                body={intl.formatMessage(
                    { id: "intl-msg:fieldCampaigns.dialogMessage" },
                    {
                        count: campaignsSize
                    }
                )}
                onClose={() => setCampaignDialog(false)}
            />
        </>);
};